$('.toggle-menu').on('click', function(e) {
    e.preventDefault();
    $('.header').toggleClass('nav-open');
    $('.header .nav').toggleClass('show');
    if($('.header .nav').hasClass('show')) {
        $(this).html('close');
    } else {
        $(this).html('menu');
    }
})

$(document).ready(init);


var scroll_updated = false;
var last_scroll_pos = 0;
var nav_down = true;
var nav_scrolled = false;
var $nav;

function init() {


    $('.clickable').on('click', function(e) {
        window.location.href = $(this).data('href');
    });

    $nav = $('.main-nav');

    scroll_updated = true;
    window.requestAnimationFrame(draw_handler);

    $(window).on('scroll', function(e) {
        scroll_updated = true;
        window.requestAnimationFrame(draw_handler);
    });


    $('.toggle-nav').on('click', function(e) {
        e.preventDefault();
        $('.main-nav').toggleClass('open');
    })

    $('.newsletter-subscribe').on('submit', function(e) {
        e.preventDefault();

        if($(this).hasClass('disabled')) return;
        $(this).addClass('disabled');
        if($(this).next().hasClass('icon')) $(this).next().addClass('icon-loading');

        send_request($(this).attr('action'), 'email=' + $(this).find('input[name="email"]').val(), newsletter_subscribed);
    });
}

function draw_handler() {
    if(scroll_updated) {
        var scroll_top = Math.max(0, document.body.scrollTop || document.documentElement.scrollTop);


        if(scroll_top > last_scroll_pos && nav_down) {
            $nav.removeClass('down');
            nav_down = false;
        }

        if(scroll_top < last_scroll_pos && !nav_down) {
            $nav.addClass('down');
            nav_down = true;
        }


        if(scroll_top <= 40 && nav_scrolled) {
            $nav.removeClass('scrolled');
            nav_scrolled = false;
        }

        if(scroll_top > 40 && !nav_scrolled) {
            $nav.addClass('scrolled');
            nav_scrolled = true;
        }

        last_scroll_pos = scroll_top;
        scroll_updated = false;
    }
}


function newsletter_subscribed() {
    var $active_form = $('.newsletter-subscribe.disabled');
    $active_form.removeClass('disabled').addClass('subscribed');

    if($active_form.next().hasClass('icon')) {
        $active_form.next().removeClass('icon-loading');
    }

}

function send_request(url, data, callback) {
    var r = new XMLHttpRequest();
    r.open("POST",  url, true);
    r.onreadystatechange = function () {
        if (r.readyState != 4 || r.status != 200) return;
        callback(JSON.parse(r.responseText));
    };
    r.send(data);
}

